import React, { Component } from "react";
import "../../../styles/commoncomponents/toggleSelector.scss";

function getContrastColor(hexColour) {
  const hex = (hexColour || "").replace("#", "");
  if (hex.length !== 6) {
    return "#ffffff";
  }

  const red = parseInt(hex.substr(0, 2), 16);
  const green = parseInt(hex.substr(2, 2), 16);
  const blue = parseInt(hex.substr(4, 2), 16);
  const luminance = (red * 299 + green * 587 + blue * 114) / 1000;
  return luminance > 155 ? "#17233c" : "#ffffff";
}

class TruckSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnAction: true,
    };
  }
  componentDidMount() {}

  handleAction = () => {
    this.setState({ btnAction: !this.state.btnAction });
    this.props.onParentCall(!this.state.btnAction, this.props.id);
  };

  handleTileClick = () => {
    if (this.props.disabled || !this.props.routeVisible || !this.props.onTileFocus) {
      return;
    }

    this.props.onTileFocus(this.props.id);
  };

  handleTileKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.handleTileClick();
    }
  };

  render() {
    const textColour = getContrastColor(this.props.colour);
    const tileStyle = {
      backgroundColor: this.props.colour,
      borderColor: this.props.colour,
      color: textColour,
    };

    return (
		<div
      role="button"
      tabIndex={this.props.disabled || !this.props.routeVisible ? -1 : 0}
      className={`truck-container${this.props.active ? " active" : ""}${!this.props.routeVisible ? " route-hidden" : ""}`}
      style={tileStyle}
      onClick={this.handleTileClick}
      onKeyDown={this.handleTileKeyDown}
    >
			<div className="truck-btn">
				{/* <button onClick={this.handleAction}>
            {this.state.btnAction ? "ON" : "OFF"}
          </button> */}
				<label className="switch" onClick={(event) => event.stopPropagation()}>
					<input
						type="checkbox"
						checked={this.state.btnAction}
						onChange={this.handleAction}
					/>
					<div className="slider round"></div>
				</label>
			</div>
			<div className="truck-name">
				<i
					className="fa fa-truck"
					style={{ color: textColour, fontSize: "23px" }}
				/>
				<span>{this.props.name}</span>
			</div>
		</div>
	);
  }
}

export default TruckSelect;
